import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "collapsible-container"
};
const _hoisted_2 = {
  class: "collapsible-header-wrapper"
};
import { inject } from 'vue';
import { ArrowDownBold } from '@element-plus/icons-vue';
export default {
  __name: 'NavBarOverlayCollapsible',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['open', 'close'],
  setup(__props, {
    emit: __emit
  }) {
    const closeNavBar = inject('closeNavBar', () => {});
    const props = __props;
    const emits = __emit;
    const toggleVisibility = () => {
      emits(props.visible ? 'close' : 'open');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: _normalizeClass(["collapsible-header", {
          'active': __props.visible
        }]),
        onClick: toggleVisibility,
        onKeydown: _withKeys(toggleVisibility, ["enter"]),
        role: "button",
        tabindex: "0"
      }, [_renderSlot(_ctx.$slots, "default"), _createVNode(_unref(ArrowDownBold), {
        class: "el-icon",
        style: {
          "flex": "0 0 auto"
        }
      })], 34)]), _withDirectives(_createElementVNode("div", {
        class: "collapsible-content",
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(closeNavBar) && _unref(closeNavBar)(...args))
      }, [_renderSlot(_ctx.$slots, "content")], 512), [[_vShow, __props.visible]])]);
    };
  }
};